import { lazy } from 'react';
import { type RouteObject } from 'react-router-dom';

import { ErrorBoundary } from '../components/ErrorBoundary';
import LearnerShell from '../shell/layout/LearnerShell';
import { ProtectedRoute } from './guards';

const ImportedDashboardPage = lazy(() => import('../features/dashboard/Dashboard'));
const EchangePlayer = lazy(() =>
  import('../features/echange').then((module) => ({ default: module.EchangePlayer }))
);
const ImportedSavedPage = lazy(() => import('../features/saved/Saved'));
const SettingsPage = lazy(() => import('../features/settings/Settings'));
const ProfilePage = lazy(() => import('../features/profile/Profile'));
const SubscriptionPage = lazy(() => import('../features/subscription/Subscription'));
const UpgradePage = lazy(() => import('../features/upgrade/Upgrade'));
const DownloadsPage = lazy(() => import('../features/downloads/Downloads'));
const HistoryPage = lazy(() => import('../features/history/History'));
const HistoryDetailPage = lazy(() => import('../features/history/HistoryDetail'));
const TeamPage = lazy(() => import('../features/team/Team'));
const UpgradeSuccessPage = lazy(() => import('../features/upgrade/UpgradeSuccess'));
const UpgradeCancelPage = lazy(() => import('../features/upgrade/UpgradeCancel'));
const EventModeEntry = lazy(() => import('../features/event/EventModeEntry'));
const EventSetupFlow = lazy(() => import('../features/event/EventSetupFlow'));
const PackReadinessScreen = lazy(() => import('../features/event/PackReadinessScreen'));
const EventTodayScreen = lazy(() => import('../features/event/EventTodayScreen'));

export const learnerRoutes: RouteObject[] = [
  {
    element: (
      <ProtectedRoute>
        <ErrorBoundary>
          <LearnerShell />
        </ErrorBoundary>
      </ProtectedRoute>
    ),
    children: [
      { path: 'event', element: <EventModeEntry /> },
      { path: 'event/setup', element: <EventSetupFlow /> },
      { path: 'event/pack/:userEventId', element: <PackReadinessScreen /> },
      { path: 'event/today/:userEventId', element: <EventTodayScreen /> },
      {
        path: 'dashboard',
        element: <ImportedDashboardPage />,
      },
      {
        path: 'learn',
        element: <EchangePlayer />,
      },
      {
        // Legacy path — old ScenarioSelector lived here. The Library sheet
        // inside EchangePlayer now serves the same purpose, so this just
        // renders the player. Kept (not Navigate'd) to preserve search-param
        // contexts like ?adminPreview=1.
        path: 'learn/categories',
        element: <EchangePlayer />,
      },
      {
        path: 'learn/categories/:id',
        element: <EchangePlayer />,
      },
      {
        path: 'learn/scenario/:id',
        element: <EchangePlayer />,
      },
      {
        path: 'saved',
        element: <ImportedSavedPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
      {
        path: 'profile',
        element: <ProfilePage />,
      },
      {
        path: 'subscription',
        element: <SubscriptionPage />,
      },
      {
        path: 'upgrade',
        element: <UpgradePage />,
      },
      {
        path: 'downloads',
        element: <DownloadsPage />,
      },
      {
        path: 'history',
        element: <HistoryPage />,
      },
      {
        path: 'history/:id',
        element: <HistoryDetailPage />,
      },
      {
        path: 'team',
        element: <TeamPage />,
      },
      {
        path: 'upgrade/success',
        element: <UpgradeSuccessPage />,
      },
      {
        path: 'upgrade/cancel',
        element: <UpgradeCancelPage />,
      },
    ],
  },
];
